export const mutationWithCallback = (
    mutation: (values: Record<string, unknown>) => Promise<unknown>,
    values: Record<string, unknown>,
    callback?: (res: unknown) => void,
): Promise<unknown> =>
    mutation({ input: { ...values } }).then((res) => callback && callback(res))

export const mutationWithReCaptcha = ({
    mutation,
    values,
    callback,
    token,
}: {
    mutation: (
        values: Record<string, unknown>,
        options?: {
            fetchOptions?: {
                headers?: Record<string, string>
            }
        },
    ) => Promise<unknown>
    values: Record<string, unknown>
    callback?: (res: unknown) => void
    token: string
}): Promise<unknown> =>
    mutation(
        { input: { ...values } },
        {
            fetchOptions: {
                headers: {
                    'g-recaptcha-response': token,
                },
            },
        },
    ).then((res) => callback && callback(res))
